import isRTL from './isRTL.js';

const getRTLPlacement = (placement, element) => {
    switch (placement) {
        case 'right': {
            return isRTL(element) ? 'left' : 'right';
        }
        case 'left': {
            return isRTL(element) ? 'right' : 'left';
        }
        default: {
            return placement;
        }
    }
};

export { getRTLPlacement as default };
//# sourceMappingURL=getRTLPlacement.js.map
